.textButton {
  display: inline-block;
  appearance: none;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--button-blue);
  padding: 4px 6px;
  touch-action: manipulation;
  border-radius: 3px;
  transition: background-color 0.1s ease-in-out;
}

.textButton:active {
  background-color: color(from currentColor srgb r g b / 0.1);
}

@media (hover: hover) {
  .textButton:hover {
    background-color: color(from currentColor srgb r g b / 0.1);
  }
}

.textButtonError {
  composes: textButton;
  color: var(--highlight-red);
}
